import React from 'react'
import { FaGraduationCap, FaUniversity, FaChalkboardTeacher, FaGlobeAsia } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const AboutSection = () => {
  const features = [
    {
      icon: <FaGraduationCap className="text-4xl text-yellow-300" />,
      title: "World-Class Education",
      description: "Cutting-edge curriculum designed to meet global academic standards."
    },
    {
      icon: <FaUniversity className="text-4xl text-yellow-300" />,
      title: "State-of-the-Art Campus",
      description: "Modern infrastructure with advanced learning facilities."
    },
    {
      icon: <FaChalkboardTeacher className="text-4xl text-yellow-300" />,
      title: "Expert Faculty",
      description: "Highly qualified professors with industry and academic expertise."
    },
    {
      icon: <FaGlobeAsia className="text-4xl text-yellow-300" />,
      title: "Global Exposure",
      description: "International collaborations and exchange programs."
    }
  ]

  return (
    <div className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328] w-full py-16 px-4'>
      <div className='max-w-6xl mx-auto'>
        <div className='text-center mb-12'>
          <h2 className='text-yellow-300 font-bold text-3xl md:text-4xl uppercase tracking-wide mb-6'>
            Best University in Dehradun – Why Maya Devi University Stands Out?
          </h2>
          <p className='text-white text-base md:text-lg max-w-4xl mx-auto leading-relaxed'>
            Discover a transformative educational journey at Maya Devi University, recognized as the best university in Dehradun for academic excellence and career-focused programs. Nestled in the heart of Dehradun, our university offers world-class faculty, state-of-the-art infrastructure, and industry-aligned courses to shape future leaders. Whether you aspire for a career in engineering, management, science, or the arts, Maya Devi University provides the perfect launchpad for your success. Join us and unlock endless opportunities for a brighter future!
          </p>
        </div>

        <div className='grid md:grid-cols-2 lg:grid-cols-4 gap-6'>
          {features.map((feature, index) => (
            <div
              key={index}
              className='bg-[#145a46] rounded-xl p-6 transform transition duration-300 hover:scale-105 hover:shadow-2xl'
            >
              <div className='flex flex-col items-center text-center'>
                {feature.icon}
                <h3 className='text-yellow-300 font-bold text-xl mt-4 mb-3'>
                  {feature.title}
                </h3>
                <p className='text-white text-sm'>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className='mt-12 text-center'>
          <p className='text-white text-base md:text-lg max-w-4xl mx-auto leading-relaxed'>
          At Maya Devi University, we are committed to nurturing not just students but future leaders who will drive innovation and create a lasting impact. As a top university in Dehradun, we provide a dynamic learning environment, industry-focused programs, and world-class faculty to empower students for a successful future.
          </p>

          <Link
            to="https://admission.maya.edu.in/"
            onClick={() => {
              window.scrollTo(0, 0);
              handleLinkClick();
            }}>
            <button
              className='mt-8 bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 text-[#0e4d38] px-8 py-3 rounded-full font-bold 
            hover:bg-yellow-400 transition duration-300 transform hover:scale-105'
            >
              Apply Now
            </button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AboutSection